module.exports = __webpack_public_path__ + "img/carousel_img.85f38fce.jpg";